import React from 'react'
import PropTypes from 'prop-types'
import { CtiLinkCompound } from './CtiLinkCompound.jsx'

const CtiLinkList = (props) => {
  const { links, classNames, buttonClasses } = props

  return links?.length > 0 ? (
    <div className={`CtiLinkList ${classNames || ''}`}>
      {links.map((el, index) => {
        return (
          <CtiLinkCompound {...el} buttonClasses={buttonClasses} key={index} />
        )
      })}
    </div>
  ) : null
}

CtiLinkList.propTypes = {
  links: PropTypes.array,
  classNames: PropTypes.string,
  buttonClasses: PropTypes.string,
}

export { CtiLinkList }
